import { getQuarterOptions, getYearOptions } from "../../services/dashboard";

/**
 *
 * @param {string} language Language
 * @param {function} setDateOptions Setter from useState to set dateOption parameter
 * @param {function} setSelectedYear Setter from useState to set selected year in parent component
 * @param {function} setSelectQuarter Setter from useState to set selected quarter in parent component
 * @returns Object with options for years and quarters
 */

export async function getYearAndQuarterData(
  language,
  setDateOptions,
  setSelectedYear,
  setSelectedQuarter
) {
  const options = {
    mostRecentDate: {
      year: "",
      quarter: "",
    },
    yearOptions: [],
    quarterOptions: {},
  };

  try {
    let quarterResponse;
    const responseYearsMonth = await getYearOptions();
    if (responseYearsMonth === "ERROR_LOADING_DATA")
      return "ERROR_LOADING_DATA";

    const { data } = responseYearsMonth;

    data.shift();

    let year;
    for (let i = 0; i < data.length; ) {
      year = data[i];
      quarterResponse = await getQuarterOptions(
        year.years_code,
        language ?? "es"
      );

      if (quarterResponse === "ERROR_LOADING_DATA") {
        data.splice(i, 1);
      } else {
        options.quarterOptions[year.years_code] = quarterResponse.data;
        i++;
      }
    }

    if (Object.keys(options.quarterOptions).length === 0)
      return "ERROR_LOADING_DATA";

    options.yearOptions = data;

    const lastYear = options.yearOptions[0].years_code;
    const lastYearOptions = options.quarterOptions[lastYear];
    const lastQuarter = lastYearOptions[lastYearOptions.length - 1].value;

    options.mostRecentDate.year = lastYear;
    options.mostRecentDate.quarter = lastQuarter;

    if (setDateOptions) setDateOptions(options);
    if (setSelectedYear) setSelectedYear(lastYear);
    if (setSelectedQuarter) setSelectedQuarter(lastQuarter);

    return options;
  } catch (error) {
    console.log("Error getting and setting year and quarter data");
    console.log(error);
    return "ERROR_LOADING_DATA";
  }
}
